import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as Msal from 'msal';
import { Observable } from 'rxjs';

/* global process, window, localStorage */
@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
  constructor() {}

  msalConfig: Msal.Configuration = {
    auth: {
      clientId: '4dfd3b9f-60db-4838-bb62-2505606179cb', //This is your client ID
      authority:
        'https://login.microsoftonline.com/ebb24e74-d367-4ff2-8906-5559fc0c8078',
      redirectUri: process.env['APPSETTING_REDIRECT_URI'],
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'localStorage', // Needed to avoid "User login is required" error.
      storeAuthStateInCookie: true, // Recommended to avoid certain IE/Edge issues.
    },
  };

  userAgentApp: Msal.UserAgentApplication = new Msal.UserAgentApplication(
    this.msalConfig
  );

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let request: any;
    const isSSO = localStorage.getItem('feeder_sso');
    if (isSSO !== null && JSON.parse(isSSO)) {
      if (window.expiresOn === undefined || window.expiresOn < new Date()) {
        let request: any = {
          scopes: [`https://graph.microsoft.com/User.Read`],
          loginHint: null,
          authority: this.userAgentApp.authority,
        };
        this.userAgentApp.acquireTokenSilent(request).then((response) => {
          window.OAuthToken = response.accessToken;
          window.expiresOn = response.expiresOn;
        });
      }
      request = req.clone({
        headers: req.headers.set('OAuth-Token', window.OAuthToken),
      });
    } else {
      const apiKey = localStorage.getItem('feeder_api_key');
      request = req.clone({
        headers: req.headers.set('x-api-key', apiKey!),
      });
    }

    return next.handle(request);
  }
}
